var map = {
	"./book.svg": 1342,
	"./building.svg": 1343,
	"./cert.svg": 1344,
	"./document-favor.svg": 1345,
	"./document.svg": 1346,
	"./document2.svg": 1347,
	"./document_search.svg": 1348,
	"./document_stamp.svg": 1349,
	"./documents3.svg": 1350,
	"./facebook.svg": 1351,
	"./file-attachment-04.svg": 1352,
	"./file-bookmark-alt.svg": 1353,
	"./file-copy-alt.svg": 1354,
	"./hammer.svg": 1355,
	"./heart.svg": 1356,
	"./instagram.svg": 1357,
	"./libra.svg": 1358,
	"./mada.svg": 1359,
	"./master-card.svg": 1360,
	"./paypal.svg": 1361,
	"./person.svg": 1362,
	"./snapchat.svg": 1363,
	"./twitter-black.svg": 1364,
	"./twitter-color.svg": 1258,
	"./twitter.svg": 1365,
	"./users-alt.svg": 1366,
	"./users.svg": 1367,
	"./visa.svg": 1368,
	"./whatsapp.svg": 1369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1107;